app.controller("EditProgramController", [
    "$scope", "ProgramService", "$stateParams", "$uibModal", "ConfirmModal", "StaticData", "Selection", "$http", "usSpinnerService", "toastr",
    function ($scope, ProgramService, $stateParams, $uibModal, ConfirmModal, StaticData, Selection, $http, usSpinnerService, toastr) {

        $scope.program = {};
        $scope.containers = [];
        var isCtrlPressed, activatedSubjects, selectedContainerId, modalOpened = false;
        var now = new Date();
        $scope.year = now.getFullYear().toString();
        $scope.season = now.getMonth() < 7 ? 'spring' : 'autumn';

        function fetchProgram() {
            usSpinnerService.spin("root");
            ProgramService.fetchOne($stateParams.programId).then(function (data) {
                $scope.program = data;
                $scope.readOnly = data.readOnly;
                fetchContainers();
            });
        }

        Selection.list({
            season: $scope.year + '-' + $scope.season,
            query: $stateParams.query || "",
            limit: 500
        }).then(function (data) {
            activatedSubjects = data.docs;
            fetchProgram();
        });

        function fetchContainers() {
            ProgramService.fetchContainersByProgram($stateParams.programId).then(function (data) {
                $scope.containers = data;
                // $scope.addedCredits = _(data).map('subjects').map(subjects => _(subjects).sumBy('credits')).sum();
                StaticData.getByKey("subject_seasons").then(function (data) {
                    $scope.containers.forEach(function (container) {
                        container.subjects.forEach(function (subject) {
                            for(var i in activatedSubjects) {
                                if(activatedSubjects[i].subject.name === subject.name
                                    && activatedSubjects[i].subject.code === subject.subject.code) {
                                    subject.activated = true
                                }
                            }
                            var filtered = _.filter(data.data.items, function (item) {
                                return item._id === subject.season;
                            });
                            subject.seasonName = filtered.length ? filtered[0].name : '';
                        })
                    })
                });

                fetchContainerTypes();
            }).catch(function (err) {
                console.error(err)
                usSpinnerService.stop("root");
            });
        }

        function fetchContainerTypes() {
            StaticData.getItemsByKey("container_types").then(function (data) {
                $scope.containerTypes = _.filter(data, function (el) {
                    return el._id !== "major"
                });
                processData();
            });
        }

        function processData() {
            $scope.major = null;
            $scope.containersByType = [];
            $scope.containerTypes.forEach(function (type) {
                $scope.containersByType.push({
                    _id: type._id,
                    name: type.name,
                    containers: _.filter($scope.containers, {"type": type._id})
                });
            });
            var ind = _.findIndex($scope.containers, {"type": "major"});
            if (ind !== -1) {
                $scope.major = $scope.containers[ind];
            }
            usSpinnerService.stop("root");
        }

        $scope.addMajor = function () {
            ProgramService.createContainer({
                name: "", type: "major", parent: null, program: $stateParams.programId
            }).then(function () {
                fetchContainers();
            });
        };

        $scope.addContainer = function (type) {
            $uibModal.open({
                controller: "AddContainer",
                templateUrl: _pb + 'admin/programs/add-container.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            programId: $stateParams.programId,
                            type: type
                        };
                    }
                }
            }).result
                .then(function () {
                    fetchContainers();
                }, function () {
                });
        };

        $scope.editContainer = function (containerId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditContainerController",
                templateUrl: _pb + 'admin/programs/edit-container.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            containerId: containerId,
                            method: ProgramService.updateContainer
                        };
                    }
                }
            }).result
                .then(function () {
                    fetchContainers();
                }, function () {
                });
        };

        $scope.removeContainer = function (containerId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "კონტეინერის წაშლა",
                message: "გსურთ ამ კონტეინერის წაშლა?"
            }).result.then(function () {
                ProgramService.removeContainer({containerId: containerId}).then(function () {
                    fetchContainers();
                });
            });
        };

        $scope.update = function () {

        };

        $scope.addSubject = function (containerId, program, $event) {
            if (containerId) selectedContainerId = containerId
            else {
                if (selectedContainerId) containerId = selectedContainerId
                else containerId = $scope.major._id
            }

            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddSubjectToContainerController",
                templateUrl: _pb + 'admin/programs/add-subject-to-container.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            savedParams: $scope.savedParams,
                            containerId: containerId,
                            semesters: $scope.program.semesters,
                            program: program,
                            method: ProgramService.createSubjectWrapper
                        };
                    }
                }
            }).result
                .then(function (result) {
                    fetchContainers();
                    $scope.savedParams = result;
                    modalOpened = false;
                }, function () {
                });
        };

        function onKeyDown(e) {
            if (e.keyCode === 17) {
                isCtrlPressed = true;
            } else if (e.keyCode === 73) {
                if (isCtrlPressed) {
                    if (!modalOpened) {
                        $scope.addSubject()
                        modalOpened = true;
                    }
                }
            }
        }

        function onKeyup(e) {
            if (e.keyCode === 17) {
                isCtrlPressed = false;
            }
        }

        document.addEventListener('keydown', onKeyDown)
        document.addEventListener('keyup', onKeyup)

        $scope.$on('$destroy', function () {
            document.removeEventListener('keydown', onKeyDown)
            document.removeEventListener('keyup', onKeyup)
        });

        $scope.editSubject = function (wrapper, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditSubjectWrapperController",
                templateUrl: _pb + 'admin/programs/edit-subject-to-container.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            wrapper: wrapper,
                            semesters: $scope.program.semesters,
                            program: $scope.program,
                            method: ProgramService.editSubjectWrapper
                        };
                    }
                }
            }).result
                .then(function () {
                    fetchContainers();
                }, function () {
                });
        };

        $scope.removeSubject = function (wrapperId) {
            ConfirmModal.show({
                title: "საგნის წაშლა",
                message: "გსურთ ამ საგნის წაშლა?"
            }).result.then(function () {
                ProgramService.deleteSubjectWrapper({wrapperId: wrapperId}).then(fetchContainers);
            });
        };

        $scope.activateSubject = function (subjectWrapperId) {
            ConfirmModal.show({
                title: "საგნის აქტივაცია",
                message: "გსურთ ამ საგნის აქტივაცია?"
            }).result.then(function () {
                Selection.activate({subjectWrapperId: subjectWrapperId}).then(function (resp) {
                    if(resp.status === "success"){
                        toastr.success('',"საგანი წარმატებით გააქტიურდა");
                    } else if (resp.status === "exists") {
                        toastr.warning('',"საგანი უკვე გააქტიურებულია");
                    } else if (resp.status === "notInProgram") {
                        toastr.warning('',"საგანი არ ეკუთვნის არცერთ პროგრამას");
                    } else {
                        toastr.error('',"დაფიქსირდა სერვერის შეცდომა");
                    }
                    fetchContainers();
                });
            });
        };


        $scope.subjectOptions = {
            editSubject: $scope.editSubject,
            removeSubject: $scope.removeSubject,
            activateSubject: $scope.activateSubject,
        };

        $scope.addLanguages = function () {
            $uibModal.open({
                controller: "AddLanguageToProgram",
                templateUrl: _pb + 'admin/languages/add-language.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            program: $scope.program._id
                        }
                    }
                }
            }).result
                .then(function () {
                    fetchContainers();
                }, function () {
                });
        }

    }
]);
